































import { Component, Vue } from 'vue-property-decorator'
import { Pipeline } from '@/api/model/pipeline'
import { PipelinePhase } from '@/api/model/pipeline-phase'
import { PipelinePhaseCategory } from '@/api/types'
import { namespace } from 'vuex-class'
import { ReferralStats } from '@/api/model/referral-stats'
const referrals = namespace('referrals')

interface PipelinePhaseCategoryHint {
    category: PipelinePhaseCategory,
    count: number,
}

@Component
export default class PipelineTabs extends Vue {
    @referrals.Getter('selectablePipelines') readonly pipelines!: Pipeline[]
    @referrals.Getter readonly selectedPipeline!: Pipeline|null
    @referrals.State readonly referralStats!: ReferralStats

    get categories(): PipelinePhaseCategory[] {
        const categories = [
            PipelinePhaseCategory.ENTRY,
            PipelinePhaseCategory.APPROACH,
            PipelinePhaseCategory.DECISION,
        ]

        return categories.filter(category => {
            return this.pipelines
                .flatMap(pipeline => pipeline.phases.map(phase => phase.category))
                .indexOf(category) >= 0
        })
    }

    get phases(): PipelinePhase[] {
        if (!this.selectedPipeline) {
            return []
        }

        return this.selectedPipeline.phases
            .filter(phase => phase.active)
    }

    get phaseCategoryHints(): PipelinePhaseCategoryHint[] {
        const hints = new Map<string, number>()

        for (const phase of this.phases) {
            const category = phase.category
            const count = hints.get(category) ?? 0
            hints.set(category, count + 1)
        }

        return Array.from(hints)
            .map(hint => ({
                category: hint[0] as PipelinePhaseCategory,
                count: hint[1],
            }))

    }

    get isOverflowing(): boolean {
        return this.phases.map(phase => phase.name).join('').length >= 100
    }

    countForPhaseCategoryHint(category: string): number {
        let count = 0

        this.referralStats.countsPerPhase
            .filter(v => {
                return this.selectedPipeline.phases.find(phase => phase.id === v.phase && phase.category === category)
            })
            .forEach(v => {
                count += v.count
            })

        return count
    }

    classesForHint(hint: PipelinePhaseCategoryHint): string[] {
        const classes = [
            `col-span-${hint.count}`,
            `pipeline-hint--${hint.category}`,
        ]

        if (hint.category === PipelinePhaseCategory.DECISION) {
            classes.push('pipeline-hint--last')
        }

        return classes
    }

    styleForPhaseTab(phase: PipelinePhase): string {
        const styles = []

        if (this.isOverflowing) {
            styles.push(`max-width: calc(80vw / ${this.phases.length})`)
        }

        return styles.join(';')
    }
}
